<template>
  <div class="loading"></div>
  <div class="mask_black"></div>
  <div class="wrap"></div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'App',
  data () {
    return {
      fpData: {},
      queryParams: null,
      btnStyle: null
    }
  },
  created () {
    const searchParams = new URLSearchParams(window.location.search)
    const paramMap = {}
    for (const [key, value] of searchParams.entries()) {
      paramMap[key] = value
    }
    const t = searchParams.get('t')
    if (!t) {
      throw new Error('缺少必要參數 t')
    }
    const urlObj = new URL(
      '/fpapi/getData/' + encodeURIComponent(t),
      window.location.origin
    )
    const fbclid = searchParams.get('fbclid')
    const gclid = searchParams.get('gclid')
    if (fbclid) {
      urlObj.searchParams.set('fbclid', fbclid)
    }
    if (gclid) {
      urlObj.searchParams.set('gclid', gclid)
    }
    const url = urlObj.toString()
    //console.log('url:', url)
    axios
      .get(url)
      .then(response => {
        if (response && response.status === 200 && response.data) {
          // console.log('response.data:',response.data)
          // console.log('paramMap:',paramMap)
          if (response.data.code === '5000' && response.data.data) {
            this.queryParams = paramMap
            this.fpData = response.data.data
            setTimeout(() => {
              this.btnFunc()
            }, 200)
          } else {
            console.error(response)
            if (response.data.msg) {
              throw new Error(response.data.msg)
            } else {
              throw new Error('未預期錯誤')
            }
          }
        } else {
          console.error(response)
          throw new Error('API無回應')
        }
      })
      .catch(err => {
        console.log(err.toString())
        location.href = 'https://www.happygocard.com.tw/'
      })
  },
  methods: {
    btnFunc () {
      location.href = this.fpData.redirectUrl
    },
    openExternalBrowser (url) {
      try {
        window.happyGoApp.openExternalBrowser(url)
      } catch (e) {
        try {
          window.webkit.messageHandlers.openExternalBrowser.postMessage(url)
        } catch (e) {
          console.error(e)
          location.href = url
        }
      }
    },
    isBlank (obj) {
      if (
        obj === undefined ||
        obj === null ||
        obj === '' ||
        obj === {} ||
        obj === 'undefined'
      ) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped></style>
